// @ts-nocheck
import * as React from 'react';
import {useEffect, useState} from 'react';
import {Helmet} from 'react-helmet-async';
import {useNavigate} from "react-router-dom";
import '../InferPage/Infer.css';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCheck} from '@fortawesome/pro-solid-svg-icons'
import toast from 'react-hot-toast';
import Waveform from 'app/components/Waveform';
import {Waveform as LoadingWaveform} from '@uiball/loaders';
import {motion} from 'framer-motion';
import {useAudioRecorder} from 'react-audio-voice-recorder';
import CircularProgress from "@mui/material/CircularProgress";
import AudioFileUploader, {FileWithPreview} from "app/components/AudioFileUploader";
import {serverUrl} from "app/constants";
import axios from "axios";
import {TaskQueue} from 'cwait';
import {FormControl, InputLabel, LinearProgress, Select, TextField, Typography} from '@mui/material';
import {Api} from "../../../store/api";
import {convertToEnglishChars} from "../../../utils/filenameMethods";
import styled from "styled-components";
import MenuItem from "@mui/material/MenuItem";
import {LayerTrackMixingArgsInput} from "app/pages/SellerCreateAcapellaStackPage/layerTrackMixingArgsInput";

const fileTypes = ["WAV"];
const vocalTypes = ["soprano", "alto", "tenor", "bass"];
const layerTypes = ["vocal-stem", "instrumental"];

// For limiting concurrent file uploads
const MAX_REQUESTS_COUNT = 5
const INTERVAL_MS = 10
let PENDING_REQUESTS = 0

const MIN_SECONDS_FOR_TRAINING = 360
const RECOMMENDED_SECONDS_FOR_TRAINING = 600

export function SellerCreateAcapellaStackPage() {
  const [performanceName, setPerformanceName] = useState('');
  const [performanceDescription, setPerformanceDescription] = useState('');
  const [previewStartSec, setPreviewStartSec] = useState(45);
  const [previewEndSec, setPreviewEndSec] = useState(75);
  // Init audioFiles to empty array, append files as they are selected
  const [audioFiles, setAudioFiles] = useState<Array<FileWithPreview>>([]);
  const [audioKey, setAudioKey] = useState(0);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const recorderControls = useAudioRecorder();
  const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState(true);

  // loading state
  const [isLoadingTraining, setIsLoadingTraining] = useState(false);

  const [totalSecSelected, setTotalSecSelected] = useState(0.0);
  const [percentage, setPercentage] = useState(0);

  // calc total upload progress
  const totalUploadProgress = audioFiles.map(audio => audio.uploadProgress).reduce((partialSum, a) => partialSum + a, 0) / audioFiles.length;
  const isUploading = audioFiles.length > 0 && totalUploadProgress != 1

  const handleNameChange = e => {
    setPerformanceName(e.target.value);
  }
  const handleDescriptionChange = e => {
    setPerformanceDescription(e.target.value);
  }

  const handlePreviewStartChange = e => {
    setPreviewStartSec(e.target.value)
  }

  const handlePreviewEndChange = e => {
    setPreviewEndSec(e.target.value)
  }

  const handleSubmit = async e => {
    e.preventDefault()
    let formData = {};
    let files = [];
    for (let i = 0; i < audioFiles.length; i++) {
      const { filename, storageBucket, storageFileName, name, vocal_type, relative_index, type, track_mixing_args } = audioFiles[i]
      files.push({
        filename,
        storageBucket,
        storageFileName,
        name,
        vocal_type,
        relative_index,
        track_mixing_args,
        type,
      });
    }

    // Structure formData to create acapella stack
    Object.assign(formData, {
      files: files,
      acapella_stack: {
        name: performanceName,
        description: performanceDescription,
        preview_start_seconds: previewStartSec,
        preview_end_seconds: previewEndSec,
      }
    })

    setIsLoadingTraining(true);

    try {
      const responseBody = await Api.createAcapellaStack(formData)
      // TODO add and redirect to success screen or acapella stack details page instead
      navigate('/app/acapellas')
    } catch (e) {
      setError('Something went wrong, please try again.')
      setTimeout(() => setError(''), 15000)
      setAudioFiles([]);
      setIsLoadingTraining(false);
    }
  }

  // TODO refactor to shareable multi-file upload/list view component (code shared with InferPage)
  const setAudioFileUploadProgress = (key, progress) => {
    setAudioFiles((prevAudioFiles) => {
      if (prevAudioFiles.length === 0 ) console.error("no audio files");
      let newAudioFiles = [];
      for(let audioFile of prevAudioFiles) {
        const newAudioFile = Object.assign({}, audioFile);
        if (newAudioFile.key === key) {
          newAudioFile.uploadProgress = progress;
        }
        newAudioFiles.push(newAudioFile);
      }
      return newAudioFiles;
    });
  }
  // Set all audiofiles to uploadProgress 0 so the useEffect audio uploader knows theyve already been queued
  const setPropertyOnAudioFilesUnderCond = (key, value, condition) => {
    setAudioFiles((prevAudioFiles) => {
      if (prevAudioFiles.length === 0 ) console.error("no audio files");
      let newAudioFiles = [];
      for(let audioFile of prevAudioFiles) {
        const newAudioFile = Object.assign({}, audioFile);
        // update value if it meets condition
        if (condition(audioFile[key])) {
          newAudioFile[key] = value;
        }
        newAudioFiles.push(newAudioFile);
      }
      return newAudioFiles;
    });
  }

  const setPropertyOnAudioFileByIndex = (key, value, index) => {
    setAudioFiles(prevAudioFiles => {
      if (prevAudioFiles.length === 0 ) console.error("no audio files");
      let newAudioFiles = [];
      // deep copy
      for(let audioFile of prevAudioFiles) {
        const newAudioFile = Object.assign({}, audioFile);
        newAudioFiles.push(newAudioFile);
      }
      newAudioFiles[index][key] = value;
      return newAudioFiles;
    })
  }


  const handleFileChange = async (files: FileList) => {
    console.log(files)
    const audios: Array<FileWithPreview> = [];
    const filenames: Array<string> = [] // Create array for filenames to sign
    for (let i = 0; i < files.length; i++) {

      // remove non-English letters and numbers from filename
      const filename = convertToEnglishChars(files[i].name)

      const audio: FileWithPreview = {
        key: audioKey + i,
        preview: URL.createObjectURL(files[i]),
        data: files[i],
        filename: filename,
        signedUrl: null,
        uploadProgress: null,
        storageBucket: null,
        storageFileName: null,
        // extra fields for layer metadata
        name: files[i].name,
        vocal_type: "soprano",
        relative_index: i,
        type: 'vocal-stem',
      };

      filenames.push(filename)
      audios.push(audio);
    }

    // Get signed urls for this list of filenames
    const responseBody = await Api.getUploadUrl('training', filenames)
    console.log(responseBody);

    for (let signedUrl of responseBody) {
      // find audiofile with this signed url's filename and add signedUrl and storage properties
      const filename = signedUrl.filename;
      for (let audioFile of audios) {

        if (audioFile.filename === filename) {
          audioFile.signedUrl = signedUrl.signed_url;
          audioFile.storageBucket = signedUrl.storageBucket;
          audioFile.storageFileName = signedUrl.storageFileName;
          break;
        }
      }
    }

    setAudioKey(audioKey + files.length); //increment key (unique id for removing from selected list)
    // Append to already selected audio files
    setAudioFiles([...audioFiles, ...audios]);
  };

  // When audio component loads metadata we update the total minutes counter 
  const handleLoadedMetadata = (e) => {
    const { duration } = e.target
    const newPercentageAdded = ((totalSecSelected + duration) / 600) * 100;
    setTotalSecSelected((secSelected) => {
       return secSelected + duration;
    });
    setPercentage((oldPercentage => {
      return oldPercentage + newPercentageAdded;
    }));
  }

  // Once we get files from client with signed Urls from server, upload to google storage
  useEffect( () => {
    let hasMoreUploadsToStart = false;
    for (const audioFile of audioFiles) {
      // Once audio files are queued, uploadProgress is set to 0 to avoid reuploading
      if (audioFile.uploadProgress === null) {
        hasMoreUploadsToStart = true;
      }
    }

    if (!hasMoreUploadsToStart) return;

    async function uploadAudioFiles() {
      const MAX_PARALLEL_UPLOADS = 5;

      // https://github.com/axios/axios/issues/1010
      const queue = new TaskQueue(Promise, MAX_PARALLEL_UPLOADS)

      // Set all audiofiles to uploadProgress 0 so they don't get uploaded again in this useEffect

      setPropertyOnAudioFilesUnderCond('uploadProgress', 0, (v) => v == null);

      // Start uploading to signed urls
      await Promise.all(audioFiles.map(queue.wrap(async audio => {
        try {
          if (audio.uploadProgress === null) {
            const upload = await axios.put( audio.signedUrl, audio.data, {
              headers: {
                'Content-Type': 'application/octet-stream',
              },
              onUploadProgress: (p) => {
                setAudioFileUploadProgress(audio.key, p.progress);
              }
            });
            if (upload.status === 200) {
              console.log(upload);
            }
          }
        } catch (e) {
          console.error(e)
        }
      })));

      // enable submit button
      setIsSubmitButtonDisabled(false);
    }

    uploadAudioFiles();
  }, [audioFiles]);

  if (isLoadingTraining) {
    return (
      <>
        <Helmet>
          <title>Training Page</title>
          <meta
            name="Controlla Voice"
            content="Generate and transform vocals using AI"
          />
        </Helmet>
        <span>
        <div className="infer">
          <h1>Create New Voice</h1>
          <div className="infer__container">
            <h3>Uploading Vocals to catalog...</h3>
            <div style={{ margin: 'auto' }}>
              <LoadingWaveform size={40} lineWeight={3.5} speed={1} color="#ff74e9" />
            </div>
          </div>
        </div>
      </span>
      </>
    );
  }

  let progressInfoEl =  (
    <div className='progress-info'>
      <Typography fontSize={20} fontFamily={"Raleway"} color={'#FFF'} fontWeight={700}>
        You need {Number((MIN_SECONDS_FOR_TRAINING - totalSecSelected) / 60).toFixed() + ':' + Number(((MIN_SECONDS_FOR_TRAINING - totalSecSelected) % 60)).toFixed()} more minutes
      </Typography>
      <Typography fontSize={18} fontFamily={"Raleway"} color={'#FF74E9'} fontWeight={300}>
        of vocals to train a good singing model
      </Typography>
    </div>
  );
  
  if (totalSecSelected > MIN_SECONDS_FOR_TRAINING) {
    progressInfoEl = (
    <div className='progress-info'>
      <Typography fontSize={20} fontFamily={"Raleway"} color={'#FFF'} fontWeight={700}>
        Add {Number((RECOMMENDED_SECONDS_FOR_TRAINING - totalSecSelected) / 60).toFixed() + ':' + Number(((RECOMMENDED_SECONDS_FOR_TRAINING - totalSecSelected) % 60)).toFixed()} more minutes
      </Typography>
      <Typography fontSize={18} fontFamily={"Raleway"} color={'#55CDC4'} fontWeight={300}>
        of vocals to train an even better model
      </Typography>
    </div>
    )
  }

  if (totalSecSelected > RECOMMENDED_SECONDS_FOR_TRAINING) {
    progressInfoEl = (
    <div className='progress-info'>
      <Typography fontSize={20} fontFamily={"Raleway"} color={'#FFF'} fontWeight={700}>
        You've got {Number((totalSecSelected) / 60).toFixed() + ':' + Number(((totalSecSelected) % 60)).toFixed()} minutes
      </Typography>
      <Typography fontSize={18} fontFamily={"Raleway"} color={'#55CDC4'} fontWeight={300}>
        That's perfect!
      </Typography>
    </div>
    )
  }


  return (
    <>
      <Helmet>
        <title>Training Page</title>
        <meta
          name="Controlla Voice"
          content="Generate and transform vocals using AI"
        />
      </Helmet>
      <span>
        <motion.div
          initial={{ translateY: '100px', opacity: 0 }}
          animate={{ translateY: "0px", opacity: 1  }}
          exit={{ translateY: "0px", opacity: 0 }}
          transition={{ duration: 0.5 }} className="infer">
          <h1>Upload Acapella Performance to Sell</h1>
          <div className="infer__container" style={{maxWidth: '1200px'}}>
            <h2>Upload vocal stems</h2>
            <h3>Make sure each audio file is aligned to the same start and end point. Use Dry vocals only.</h3>

            <TextField value={performanceName} id="filled-basic" label="Name of Song/Performance" variant="filled" onChange={handleNameChange}/>
            <p></p>
            <TextField value={performanceDescription} id="filled-basic" label="Description of Song/Performance" variant="filled" onChange={handleDescriptionChange}/>
            <p></p>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'stretch' }}>
              <TextField type="number" value={previewStartSec} id="filled-basic" label="Preview Start Time (sec)" variant="filled" onChange={handlePreviewStartChange}/>
              <TextField type="number" value={previewEndSec} id="filled-basic" label="Preview End Time (sec)" variant="filled" onChange={handlePreviewEndChange}/>

            </div>
            <AudioFileUploader
                isTraining
                isUploading={isUploading}
                handleChange={handleFileChange}
                fileWithPreviews={audioFiles}
                renderAudioFilePreview={(audio, index) => {
                  if (!audio.preview) return;

                  const circleProgressEl = (
                      <>
                        <CircularProgress variant="determinate" value={audio.uploadProgress * 100} color="secondary" size={40} thickness={6}/>
                        <CircularProgress color="secondary" size={40} thickness={6} sx={{
                          top: 0,
                          left: 0,
                          bottom: 0,
                          right: 0,
                          position: 'absolute',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          opacity: '0.3',
                        }}/>
                      </>
                  )

                  let waveformEl = (
                      // @ts-ignore
                      <Waveform uniqueKey={audio.key} url={audio.preview} onLoadedMetadata={handleLoadedMetadata}  downloadButtonElement={circleProgressEl}/>
                  );

                  // Layer Name input for each audio file
                  const handleLayerNameChange = (e) => {
                    setPropertyOnAudioFileByIndex('name', e.target.value, index);
                  }

                  let layerNameInput = (
                      <TextField value={audio.name} id="filled-basic" label="Layer Name" variant="filled" onChange={handleLayerNameChange}/>
                  )

                  // Vocal type input for each audio file
                  const handleLayerVocalTypeChange = (e) => {
                    setPropertyOnAudioFileByIndex('vocal_type', e.target.value, index);
                  }
                  let vocalTypeSelect = (
                      <FormControl variant="filled" fullWidth>
                        <InputLabel id="select-vocal-type-label">Vocal Range</InputLabel>
                        <Select
                            labelId="select-vocal-type-label"
                            id="select-vocal-type"
                            variant="filled"
                            value={audio.vocal_type}
                            label="Vocal Range"
                            onChange={handleLayerVocalTypeChange}
                        >
                          {vocalTypes.map(vt => (
                            <MenuItem value={vt}>{vt}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                  )

                  // Layer type input for each audio file
                  const handleLayerTypeChange = (e) => {
                    setPropertyOnAudioFileByIndex('type', e.target.value, index);
                  }
                  let layerTypeSelect = (
                      <FormControl variant="filled" fullWidth>
                        <InputLabel id="select-type-label">Layer Type</InputLabel>
                        <Select
                            labelId="select-type-label"
                            id="select-layer-type"
                            variant="filled"
                            value={audio.type}
                            label="Vocal Range"
                            onChange={handleLayerTypeChange}
                        >
                          {layerTypes.map(t => (
                              <MenuItem value={t}>{t}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                  )

                  // Relative index input for each audio file
                  const handleRelativeIndexChange = (e) => {
                    setPropertyOnAudioFileByIndex('relative_index', e.target.value, index);
                  }

                  let layerRelativeIndexInput = (
                      <TextField inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} value={audio.relative_index} id="filled-basic" label="Index" variant="filled" onChange={handleRelativeIndexChange}/>
                  )

                  // Mixing args input
                  const handleTrackMixingArgsChange = (v) => {
                    console.log(v)
                    setPropertyOnAudioFileByIndex('track_mixing_args', v, index);
                  }

                  let popperId = 'popper-mixing-args-' + index
                  let layerTrackMixingArgsInputModal = (
                      <LayerTrackMixingArgsInput id={popperId} value={audio.track_mixing_args} onTrackMixingArgsChange={handleTrackMixingArgsChange} />
                  )

                  if (audio.uploadProgress === 1) {
                    waveformEl = (
                        // @ts-ignore
                        <Waveform uniqueKey={audio.key} url={audio.preview} downloadButtonElement={
                          (
                              <FontAwesomeIcon icon={faCheck} size="40px" />
                          )
                        }/>
                    );
                  }
                  return (
                      <AudioFileListItem key={audio.key}>
                        <AudioFileName>
                          {layerNameInput}
                        </AudioFileName>
                        <AudioVocalType>
                          {vocalTypeSelect}
                        </AudioVocalType>
                        <AudioLayerType>
                          {layerTypeSelect}
                        </AudioLayerType>
                        <AudioRelativeIndex>
                          {layerRelativeIndexInput}
                        </AudioRelativeIndex>
                        {layerTrackMixingArgsInputModal}
                        {waveformEl}
                      </AudioFileListItem>
                  );
                }}/>

            {audioFiles.length > 0 && (
                <LinearProgress variant="determinate" value={totalUploadProgress * 100} color={totalUploadProgress == 1 ? "success" : "primary"}/>
            )}

            {error !== '' && (
              <p className="error">{error}</p>
            )}
            {audioFiles.length !== 0 && (
              <div className="training__footer">
                <button className="primary-button" onClick={handleSubmit} disabled={isSubmitButtonDisabled}>Create Song</button>
              </div>
            )}
          </div>
        </motion.div>
      </span>
    </>
  );
}


const AudioFileListItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  
  margin-bottom: 20px;
`;

const AudioFileName = styled.div`
  font-family: 'Jura', sans-serif;
  font-size: 18px;
  padding-left: 10px;
  text-align: left;
  min-width: 200px;
`;
const AudioVocalType = styled.div`
  font-family: 'Jura', sans-serif;
  font-size: 18px;
  padding-left: 10px;
  text-align: left;
  flex-shrink: 0;
  min-width: 140px;
`;
const AudioLayerType = styled.div`
  font-family: 'Jura', sans-serif;
  font-size: 18px;
  padding-left: 10px;
  text-align: left;
  flex-shrink: 0;
  min-width: 140px;
`;
const AudioRelativeIndex = styled.div`
  font-family: 'Jura', sans-serif;
  font-size: 18px;
  padding-left: 10px;
  padding-right: 10px;
  text-align: left;
`;
